import { assetsUrl } from 'sly/config';

export const assetPath = (url: string) => `${assetsUrl}/${url}`;
